import ReactApexChart from 'react-apexcharts'
import { useTranslation } from 'react-i18next'

import { getRadialChartOptionsAndData } from './dataConverter'
import { ChartData } from '@/Atomic/Organisms/Charts/acBar/dataConverter'
import '../ChartError.scss'
import '../Charts.scss'

interface Param {
  salesData: ChartData | undefined
  showLegend: boolean
}

export function AcRadialChart({
  salesData = undefined,
  showLegend = false,
}: Param) {
  const { t } = useTranslation()

  if (!salesData) {
    return <div></div>
  }

  let options

  try {
    const result = getRadialChartOptionsAndData(salesData, showLegend)
    options = result.options
  } catch (error) {
    console.error(
      'Error processing radial chart data:',
      error instanceof Error ? error.message : 'Unknown error',
    )
    return (
      <div className="chart-error">
        {t('components.dashboard.chart.unableToRender')}
      </div>
    )
  }

  const chartOptions = {
    ...options,
    chart: {
      ...options.chart,
      type: 'radialBar' as const,
    },
    labels: options.labels.map((label) => label ?? ''),
  }

  return (
    <div className="AcRadialChart">
      <ReactApexChart
        options={chartOptions}
        series={options.series}
        type="radialBar"
        width="100%"
        height="100%"
      />
    </div>
  )
}
